import React, { useEffect } from "react";
import StripeButton from "./StripeButton";
import { useSelector, useDispatch } from "react-redux";
import { getAffiliateAccount, GET_AFFILIATE_ACCOUNT_SUCCESS, getAffiliateIntroductions } from "../../actions/affiliateAccount";
import { Spinner, ImgIcon } from "../../assets";
import StripeDashboardButton from "./StripeDashboardButton";
import { useState } from "react";
import { vendorPath } from "../../helpers";

export default function Introductions() {

	const dispatch = useDispatch();
	const { affiliateAccount, user } = useSelector(state => ({
		user: state.session.user,
		affiliateAccount: state.affiliateAccount
	}));

	const { loading, introductions } = affiliateAccount;

	useEffect(() => {
		if (user.affiliateAccount) {
			dispatch(getAffiliateAccount());
			dispatch(getAffiliateIntroductions());
		}
	}, [dispatch, user.affiliateAccount]);

	if (user.affiliateAccount && loading) return <Spinner
		color="#000000"
		size={50}
		fullscreen={true}
	/>;

	return <>

		{/* Referral link */}
		{Boolean(affiliateAccount.id) && <section>
			<h4>Make some intros</h4>
			<div className="inner introductions-summary">
				This is your introducer link. Anyone who follows the link, then signs up and creates a shop will count as your referral. We'll then kick back 0.5% of all of their sales to you.
				<br /><br />
				Click to copy it.
				<br /><br />
				<CopyAble value={`${window.location.protocol}//${window.location.host}/intro/${affiliateAccount.code}`} />
			</div>
		</section>}

		{/* Show introductions */}
		{Boolean(affiliateAccount.id) && <section>
			<h4>Your introductions</h4>
			{introductions.length ?
				<div className="inner introductions-summary">
					Here are the Shops you're responsible for introducing:
					<br /><br />
					{introductions.map(vendor => (
						<a
							className="introduction brand-bg"
							key={vendor.id}
							href={vendorPath(vendor.slug)}
							target="_blank"
							rel="noopener noreferrer"
							title="Visit shop"
						>
							{vendor.logo && <ImgIcon size={46} src={vendor.logo.url} />}
							<span className="featureFont upperCase" >
								{vendor.name}
							</span>
						</a>
					))}
				</div>
				:
				<div className="inner">
					When you've made an introduction and that user sets up a shop, they'll appear here for you to see.
				</div>}
		</section>}

		{/* If they don't have an account, show the prompt to set one up */}
		{!Boolean(affiliateAccount.id) && <section>
			<h4>Spreading the word about Orderabl+</h4>
			<div className="inner">
				Orderabl+ is a tool for the community, so we want to grow it with the community's help!
				<br /><br />
				If you recommend Orderabl+ to a friend or colleague, and they go on to set up a shop, we'll kick back to you <b>0.5%</b> of all sales that they make. It's our way of saying thank you for being awsome and supporting the project!
				<br /><br />
				If you want to start introducing people to Orderabl+, click the button below. It will guide you through setting up your Stripe account so you can get paid out securely.
				<br /><br />
				<StripeButton
					handlerUrl="/affiliate-accounts/stripe/connect"
					onSuccess={affiliateAccount => {
						dispatch({
							type: GET_AFFILIATE_ACCOUNT_SUCCESS,
							affiliateAccount
						})
					}}
				/>
			</div>
		</section>}

		{/* Otherwise, show the dashboard link. */}
		{Boolean(affiliateAccount.id) && <section>
			<h4>Your introducer account</h4>
			<div className="inner">
				Hello Orderabl+ introducer!
				<br /><br />
				If you want to have a look at your Stripe dashboard and check on your next payouts, click the button below:
				<br /><br />
				<StripeDashboardButton handlerUrl="/affiliate-accounts/stripe/dashboard-link" />
			</div>
		</section>}

	</>
}

function CopyAble({ children, value, style = {}, ...props }) {

	const inputValue = (children || value);
	const [clicked, setClicked] = useState(false);

	useEffect(() => {
		let to;
		if (clicked) to = setTimeout(() => {
			setClicked(false);
		}, 2000);
		return () => {
			clearTimeout(to);
		}
	}, [clicked]);

	return <div className="copyable">
		<input
			style={{ cursor: "pointer", ...style }}
			{...props}
			type="text"
			readOnly={true}
			value={inputValue}
			onClick={e => {
				setClicked(true);
				e.target.select();
				document.execCommand("copy");
				e.target.blur();
			}}
		/>
		{clicked && <div className="tooltip">
			Copied!
		</div>}
	</div>
}